export default (method, delay) => {
  clearTimeout(method._tId);
  method._tId = setTimeout(() => {
    method();
  }, delay);
};
